<template>
  <div>
    <!-- BUTTON SELECTION -->
    <div v-if="data.tag !== undefined && data.tag !== null">
      <div v-if="btnSpin == false">
        <v-btn icon v-if="data.btn == 'icon'" :color="ui.bkgdColor"
        @click="getDocumentInfoCardData()">
          <v-icon :color="ui.btnColor">
            {{this.defineDocumentFromTag(this.data.tag).icon}}
          </v-icon>
        </v-btn>
        <v-btn flat v-if="data.btn == 'flat'" :color="ui.btnColor"
        @click="getDocumentInfoCardData()">
          <v-icon left>
            {{this.defineDocumentFromTag(this.data.tag).icon}}
          </v-icon>
            {{this.defineDocumentFromTag(this.data.tag).title}}
        </v-btn>
      </div>
      <div v-else>
        <BtnSpin v-if="data.size == 'icon'" :btnSpec="btnInfo1"/>
        <BtnSpin v-if="data.size == 'flat'" :btnSpec="btnInfo2"/>
      </div>
    </div>
    <v-dialog v-model="dialog" persistent :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.cardColor">
        <v-card-title>
          <v-icon large left :color="ui.iconColor">
            {{this.defineDocumentFromTag(this.localForm.tag).icon}}
          </v-icon>
          <span :class="ui.textTitle">
            {{localForm.title}}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container :class="ui.bkgdColor">
            <div>
              <v-layout>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> short_text </v-icon>
                  </v-avatar>
                  Facility Description
                </v-chip>
                <v-spacer/>
              </v-layout>
              <v-layout class="ml-3 mr-3 mt-1">
                <v-flex xs11 offset-xs1>
                  <div :class="ui.textSubheadingGrey">
                    {{localForm.des}}
                  </div>
                </v-flex>
              </v-layout>
            </div>
            <div>
              <v-layout class="mt-4">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> alternate_email </v-icon>
                  </v-avatar>
                  Contact Information
                </v-chip>
                <v-spacer/>
              </v-layout>
              <v-layout class="ml-3 mr-3 mt-1"
              v-if="localForm.epri !== ''">
                <v-flex xs11 offset-xs1>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> email </v-icon>
                    </v-avatar>
                    {{localForm.epri}}
                  </v-chip>
                </v-flex>
              </v-layout>
              <v-layout class="ml-3 mr-3 mt-1"
              v-if="localForm.esec !== ''">
                <v-flex xs11 offset-xs1>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> mark_email_unread </v-icon>
                    </v-avatar>
                    {{localForm.esec}}
                  </v-chip>
                </v-flex>
              </v-layout>
              <v-layout class="ml-3 mr-3 mt-1"
              v-if="localForm.ppri !== ''">
                <v-flex xs11 offset-xs1>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> dialpad </v-icon>
                    </v-avatar>
                    {{localForm.ppri}}
                  </v-chip>
                </v-flex>
              </v-layout>
              <v-layout class="ml-3 mr-3 mt-1"
              v-if="localForm.psec !== ''">
                <v-flex xs11 offset-xs1>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> call </v-icon>
                    </v-avatar>
                    {{localForm.psec}}
                  </v-chip>
                </v-flex>
              </v-layout>
              <v-layout class="ml-3 mr-3 mt-1"
              v-if="false">
                <v-flex xs11 offset-xs1>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> http </v-icon>
                    </v-avatar>
                    {{localForm.web}}
                  </v-chip>
                </v-flex>
              </v-layout>
              <v-layout class="ml-3 mr-3 mt-4"
              v-if="localForm.lstate !== ''">
                <v-flex xs11 offset-xs1>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> public </v-icon>
                    </v-avatar>
                    {{localForm.lcountry}}, {{localForm.lstate}}
                  </v-chip>
                </v-flex>
              </v-layout>
              <v-layout class="ml-3 mr-3 mt-1"
              v-if="localForm.lcity !== '' && localForm.lpost !== ''">
                <v-flex xs11 offset-xs1>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> location_city </v-icon>
                    </v-avatar>
                    {{localForm.lcity}}, {{localForm.lpost}}
                  </v-chip>
                </v-flex>
              </v-layout>
              <v-layout class="ml-3 mr-3 mt-1"
              v-if="localForm.ladd !== ''">
                <v-flex xs11 offset-xs1>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> home </v-icon>
                    </v-avatar>
                    {{localForm.ladd}}
                  </v-chip>
                </v-flex>
              </v-layout>
            </div>


            <div>
              <v-layout class="mt-4">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> explore </v-icon>
                  </v-avatar>
                  Facility Operations
                </v-chip>
                <v-spacer/>
              </v-layout>
              <v-layout class="ml-3 mr-3 mt-2">
                <v-flex xs11 offset-xs1>
                  <div :class="ui.textSubheadingGrey">
                    {{localForm.scope}}
                  </div>
                </v-flex>
              </v-layout>
              <v-layout class="ml-3 mr-3 mt-4">
                <v-flex xs11 offset-xs1 sm5>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> grid_view </v-icon>
                    </v-avatar>
                    {{localForm.theme}}
                  </v-chip>
                </v-flex>
                <v-flex xs11 offset-xs1 sm5 class="hidden-xs-only">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> factory </v-icon>
                    </v-avatar>
                    {{localForm.type}}
                  </v-chip>
                </v-flex>
              </v-layout>
              <v-layout class="ml-3 mr-3 mt-1">
                <v-flex xs11 offset-xs1 sm5>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> login </v-icon>
                    </v-avatar>
                    {{localForm.out}}
                  </v-chip>
                </v-flex>
                <v-flex xs11 offset-xs1 sm5 class="hidden-xs-only">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> priority_high </v-icon>
                    </v-avatar>
                    {{localForm.risk}}
                  </v-chip>
                </v-flex>
              </v-layout>
              <v-layout class="ml-3 mr-3 mt-1">
                <v-flex xs11 offset-xs1 sm5>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> warehouse </v-icon>
                    </v-avatar>
                    {{localForm.site}}
                  </v-chip>
                </v-flex>
                <v-flex xs11 offset-xs1 sm5 class="hidden-xs-only">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> work_outline </v-icon>
                    </v-avatar>
                    {{localForm.work}}
                  </v-chip>
                </v-flex>
              </v-layout>
            </div>
            <v-layout class="mt-4 mr-3" v-if="false">
              <v-spacer/>
              <DocumentStatus :data="{
                model: 'SMALL',
                rev: this.displayDocumentRevTypeA(this.rev),
                sec: localForm.revsec,
                stat: localForm.revstat,
                type: localForm.revtype}
                "/>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="closeDialog()" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import DocumentStatus from "@/document/revisions/components/DocumentStatus";
import describeDocument from "@/data/describe/mixins/describeDocument";
import revFunctions from "@/data/functions/mixins/revFunctions.js";
import revs from "@/data/forms/mixins/revs.js";
import { mapGetters } from "vuex";
export default {
  props: {
    data: {
      type: Object
    }
  },
  components: {
    BtnSpin,
    DocumentStatus
  },
  watch: {
    dataSaved() {
      if (this.ctr === 1) {
        this.ctr = this.ctr + 1;
        this.dialog = true;
      }
    }
  },
  // eslint-disable-next-line
  mixins: [
    apptheme,
    numberFunctions,
    getData,
    dateFunctions,
    displayFunctions,
    describeDocument,
    displayFunctions,
    revFunctions,
    revs
  ],
  data() {
    return {
      valid: true,
      dialog: false,
      ctr: 0, // this prevent bounce that lead to overstack limt
      btnSpin: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "icon"
      },
      btnInfo2: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: ""
      },
      localForm: {
        id: "Undefined ID",
        idg: "Undefined IDG",
        did: "",
        title: "Undefined Title",
        tag: "B1", // intial to allow functions to load
        theme: "",
        type: "",
        scope: "",
        out: "",
        work: "",
        site: "",
        risk: "",
        des: "",
        epri: "",
        esec: "",
        ladd: "",
        lcity: "",
        lcountry: "",
        llink: "",
        lpost: "",
        lstate: "",
        ppri: "",
        psec: "",
        web: "",
        qr: "",
        stry: "",
        val: "",
        mis: ""
      },
      rev: {}
    };
  },
  created() {
    this.rev = this.formDocumentRevision;
  },
  updated() {
    // fix orginal data before change
    if (this.getInfoCard !== null) {
      // BASIC
      this.localForm.id = this.getInfoCard.basic.id;
      this.localForm.idg = this.getInfoCard.basic.idg;
      this.localForm.tag = this.getInfoCard.basic.tag;
      this.localForm.did = this.getInfoCard.basic.did;
      this.localForm.title = this.getInfoCard.basic.title;

      // CHAR
      this.localForm.theme = this.getInfoCard.char.theme;
      this.localForm.type = this.getInfoCard.char.type;
      this.localForm.site = this.getInfoCard.char.site;
      this.localForm.scope = this.getInfoCard.char.scope;
      this.localForm.risk = this.getInfoCard.char.risk;
      this.localForm.out = this.getInfoCard.char.out;
      this.localForm.risk = this.getInfoCard.char.risk;
      this.localForm.work = this.getInfoCard.char.work;
      this.localForm.des = this.getInfoCard.char.des;

      this.localForm.epri = this.getInfoCard.char.epri;
      this.localForm.esec = this.getInfoCard.char.esec;
      this.localForm.ladd = this.getInfoCard.char.ladd;
      this.localForm.lcity = this.getInfoCard.char.lcity;
      this.localForm.lcountry = this.getInfoCard.char.lcountry;
      this.localForm.llink = this.getInfoCard.char.llink;
      this.localForm.lpost = this.getInfoCard.char.lpost;
      this.localForm.lstate = this.getInfoCard.char.lstate;
      this.localForm.ppri = this.getInfoCard.char.ppri;
      this.localForm.psec = this.getInfoCard.char.psec;
      this.localForm.qr = this.getInfoCard.char.qr;
      this.localForm.web = this.getInfoCard.char.web;

      this.localForm.stry = this.getInfoCard.char.stry;
      this.localForm.val = this.getInfoCard.char.val;
      this.localForm.mis = this.getInfoCard.char.mis;
    }
  },
  computed: {
    ...mapGetters(["getInfoCard", "getUser", "getRegisterInfo"]),
    dataSaved() {
      let saved = false;
      if (this.getInfoCard !== null && this.ctr === 1) {
        saved = true;
        // this.ctr = this.ctr + 1;
      } else {
        saved = false;
      }
      return saved;
    }
  },
  methods: {
    closeDialog() {
      // reset store
      // this.$store.dispatch("changeCompany", null);
      this.btnSpin = false;
      this.dialog = false;
      this.ctr = 0;
      this.$store.dispatch("changeInfoCard", null);
    },
    getDocumentInfoCardData() {
      if (this.ctr === 0) {
        this.ctr = this.ctr + 1;
        this.btnSpin = true;
        this.getDocumentInfoCard(this.data.tag, this.data.did);
      }
    }
  }
};
</script>
